module.exports = __webpack_public_path__ + "img/card_nevi_ElecrtrifyAmerica_4.09cf9dc2.png";